export default "__VITE_ASSET__oJCXY2IG__"